import React from 'react'
import PropTypes from 'prop-types'
import { ErrorMsg } from '../../../Components/Form'

class Login extends React.Component {

  static propTypes = {
    messageHtml: PropTypes.string,
    errorHtml:   PropTypes.string,
    top:         PropTypes.element.isRequired,
    bottom:      PropTypes.element.isRequired,

    dict: PropTypes.shape({
      or: PropTypes.string.isRequired,
    })
  }

  static defaultProps = {
    formIsVisible: true,
    location:      window.location.search,
  }

  render() {
    const {
      messageHtml,
      errorHtml,
      top,
      bottom,
      dict,
    } = this.props

    return (
      <div className="coreform-container loginform-container">

        { messageHtml &&
          <ErrorMsg className="login-msg">{ messageHtml }</ErrorMsg> }

        { errorHtml &&
          <ErrorMsg className="login-error">{ errorHtml }</ErrorMsg> }

        { top }

        <div className="signup-ordivider">{ dict.or }/></div>

        { bottom }

      </div>
    )
  }
}

export { Login }
